// extracted by mini-css-extract-plugin
export default {"nav":"gURvGsUi","link":"knj4FDiz","linkActive":"rkkVa1Hf","title":"ZqApi785","hiddenOnMobile":"bhUAuhkK","divider":"eAbACa8v bhUAuhkK","updateDot":"_xP5hL7Z"};